import React from 'react';
import { Card, Typography } from 'antd';
import SignInForm from './SignInForm';
import './SignInPage.scss';

const { Title } = Typography;

const SignInPage = () => {
  return (
    <div className={'SignInPage'}>
      <Card title="" className={'SignInPage__CardLogin'}>
        <div className={'SignInPage__CardLogin__div'}>
          <Title level={1} className={'SignInPage__CardLogin__title'}>
            Bienvenido a
          </Title>
          <img src={'/assets/images/logo_teinnova.png'} alt={'Teinnova Logo'} />
        </div>
        <SignInForm />
        <div className={'SignInPage__CardLogin__footer'}>
          <div className="SignInPage__CardLogin__footer__right">
            <img src={'/assets/images/ader.png'} alt="ADER" />
            <img src={'/assets/images/next_generation_eu.png'} alt="Next Generation EU" />
          </div>
          <div className="SignInPage__CardLogin__footer__right">
            <img src={'/assets/images/gobierno_españa.png'} alt="Gobierno de España" />
            <img src={'/assets/images/plan_transformacion.png'} alt="Plan Transformación" />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SignInPage;
